import { React } from 'react';
import { Flex, Text, Checkbox } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

function SoftSkillsCheckbox({ skillA, skillB }) {
  const methods = useFormContext();

  return (
    <Controller
      name='Communication_Skills'
      control={methods.control}
      render={({ field: { onChange, value } }) => {
        const curatedValue = value ?? [];

        const handleChange = e => {
          // If target becomes checked, filter out both skills, then let's add it's value to the array
          if (e.target.checked) {
            onChange([
              ...(curatedValue ? curatedValue.filter(option => option !== skillA && option !== skillB) : []),
              e.target.value,
            ]);
          } // Else it means it was already present, so just filter out both skills
          else
            onChange([
              ...(curatedValue !== undefined
                ? curatedValue.filter(option => option !== skillA && option !== skillB)
                : []),
            ]);
        };

        return (
          <Flex width='100%'>
            <Checkbox
              size='lg'
              value={skillA}
              isChecked={!!value?.find(skill => skill === skillA)}
              onChange={handleChange}
              width='50%'>
              <Text fontSize='14px'>{skillA}</Text>
            </Checkbox>
            <Checkbox
              size='lg'
              value={skillB}
              isChecked={!!value?.find(skill => skill === skillB)}
              onChange={handleChange}
              width='50%'>
              <Text fontSize='14px'>{skillB}</Text>
            </Checkbox>
          </Flex>
        );
      }}
    />
  );
}

export default SoftSkillsCheckbox;
